module.exports = __webpack_public_path__ + "static/media/CSS.0fc9d143.png";